export default "__VITE_PUBLIC_ASSET__1e5732d4__"